@use "sass:meta";

.la-decorate-terms__popup {
  position: relative;
  @include meta.load-css("~tippy.js/dist/tippy.css");
  @include meta.load-css("~tippy.js/themes/light-border.css");
  @include meta.load-css("../../styles/tippy");
}

la-akoma-ntoso.show-terms .akn-term {
  text-decoration: underline dotted 1px;
}

la-akoma-ntoso.link-terms .akn-term {
  cursor: pointer;
}
